/* eslint-disable no-return-assign */
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { DropdownButton, MenuItem, Alert } from 'react-bootstrap';
import { injectIntl } from 'react-intl';
import { findIndex as _findIndex, filter as _filter } from 'lodash';

import { addNotification } from 'actions/NotificationsActions';

import Breadcrumb from 'components/layout/Breadcrumb';
import Loader from 'components/layout/Loader';

import PluginItem from 'components/layout/plugin/PluginItem';
import PluginDetails from 'components/modals/PluginDetails';
import PluginSettings from 'components/modals/PluginSettings';
import PluginActivate from 'components/modals/PluginActivate';
import PluginTerminate from 'components/modals/PluginTerminate';

import List from 'components/List';

import DocMeta from 'components/DocMeta';
import { generateMetaTags } from 'helpers/metaTags';

class Plugins extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      showDetails: false,
      detailsPlugin: null,
      showSettings: false,
      settingsPlugin: null,
      showActivate: false,
      showTerminate: false,
      selectedWhiteLabel: null,
    };
  }

  showDetails = detailsPlugin => {
    this.setState({ showDetails: true, detailsPlugin });
  };

  closePopup = () => {
    this.setState({ showDetails: false, showActivate: false, showTerminate: false, showSettings: false });
  };

  getBreadcrumb = () => {
    const {
      intl: { messages },
      appIntl,
    } = this.props;
    return (
      <Breadcrumb
        crumbs={[
          { link: appIntl.urlPrefix + 'account', name: 'Dashboard' },
          { link: appIntl.urlPrefix + 'account/settings', name: messages.settings },
          { link: null, name: messages.plugins },
        ]}
        className="p-t-0"
      />
    );
  };

  componentDidUpdate = prevProps => {
    const {
      intl: { messages },
      myWhiteLabelProject,
      pluginSettingsFormStatus,
      pluginActivateFormStatus,
      pluginTerminateFormStatus,
      doNotify,
    } = this.props;
    const { selectedWhiteLabel } = this.state;

    if (
      prevProps.myWhiteLabelProject.pending &&
      !myWhiteLabelProject.pending &&
      !myWhiteLabelProject.hasError &&
      !selectedWhiteLabel
    ) {
      this.setState({
        selectedWhiteLabel: myWhiteLabelProject.data.list.length ? myWhiteLabelProject.data.list[0] : null,
      });
    }

    if (
      prevProps.pluginSettingsFormStatus.pending &&
      !pluginSettingsFormStatus.pending &&
      !pluginSettingsFormStatus.hasError
    ) {
      doNotify(1, messages.settings_saved);

      if (selectedWhiteLabel.id === pluginSettingsFormStatus.response.id) {
        this.setState({ showSettings: false, selectedWhiteLabel: pluginSettingsFormStatus.response });
      } else {
        this.setState({ showSettings: false });
      }
    }

    if (
      prevProps.pluginActivateFormStatus.pending &&
      !pluginActivateFormStatus.pending &&
      !pluginActivateFormStatus.hasError
    ) {
      this.setState({ selectedWhiteLabel: pluginActivateFormStatus.response });
    }

    if (
      prevProps.pluginTerminateFormStatus.pending &&
      !pluginTerminateFormStatus.pending &&
      !pluginTerminateFormStatus.hasError
    ) {
      this.setState({ selectedWhiteLabel: pluginTerminateFormStatus.response });
    }
  };

  isPluginIdActive = pluginId => {
    const { selectedWhiteLabel } = this.state;

    if (selectedWhiteLabel) {
      const pluginIndex = _findIndex(selectedWhiteLabel.plugins, ['id', pluginId]);
      if (pluginIndex >= 0) {
        return selectedWhiteLabel.plugins[pluginIndex].is_active;
      }
    }

    return false;
  };

  isPluginActive = plugin => {
    if (plugin) {
      return this.isPluginIdActive(plugin.id);
    }

    return false;
  };

  // check if plugin activation is in progress
  getActivationPending = plugin => {
    const { pluginActivationRequests } = this.props;
    for (let i = 0; i < pluginActivationRequests.data.list.length; i++) {
      const pluginActivationRequest = pluginActivationRequests.data.list[i];
      if (pluginActivationRequest.plugin.id === plugin.id) {
        return true;
      }
    }

    return false;
  };

  // check if plugin termination is in progress
  getTerminationPending = plugin => {
    const { pluginTerminationRequests } = this.props;
    for (let i = 0; i < pluginTerminationRequests.data.list.length; i++) {
      const pluginTerminationRequest = pluginTerminationRequests.data.list[i];
      if (pluginTerminationRequest.plugin.id === plugin.id) {
        return true;
      }
    }

    return false;
  };

  hasSepaAgreement = plugin => {
    const { sepaAgreements } = this.props;
    if (plugin && !sepaAgreements.pending) {
      return _findIndex(sepaAgreements.data.list, { is_active: true, target: plugin.owner.id }) > -1;
    }

    return false;
  };

  // listen if user wished to activate or terminate a plugin
  pluginActivationChange = (plugin, checked) => {
    if (checked) {
      // user wishes to activate the plugin
      this.setState({ showDetails: false, showTerminate: false, showActivate: true, detailsPlugin: plugin });
    } else {
      // user wishes to terminate the plugin
      this.setState({ showDetails: false, showTerminate: true, showActivate: false, detailsPlugin: plugin });
    }
  };

  showSettings = settingsPlugin => {
    this.setState({ showSettings: true, settingsPlugin });
  };

  displayPlugin = (
    plugin,
    pluginActive,
    activationPending = false,
    terminationPending = false,
    hasSepaAgreement = true
  ) => {
    const { list } = this.props;
    const { selectedWhiteLabel } = this.state;

    const dependentPlugins = _filter(list.data.list, ['dependent_on', plugin.id]);

    return (
      <PluginItem
        key={plugin.id}
        plugin={plugin}
        pluginActive={pluginActive}
        dependentPlugins={dependentPlugins}
        activationPending={activationPending}
        terminationPending={terminationPending}
        hasSepaAgreement={hasSepaAgreement}
        whiteLabel={selectedWhiteLabel}
        onPluginActivationChange={(plugin, checked) => this.pluginActivationChange(plugin, checked)}
        onShowDetails={this.showDetails}
        onShowSettings={this.showSettings}
      />
    );
  };

  render() {
    const {
      intl: { messages },
      list,
      myWhiteLabelProject,
      sepaAgreements,
      externalAccountsStats,
      pluginActivationRequests,
      pluginTerminationRequests,
    } = this.props;
    const {
      showActivate,
      showDetails,
      showTerminate,
      showSettings,
      detailsPlugin,
      settingsPlugin,
      selectedWhiteLabel,
    } = this.state;

    let title = messages.plugins;
    if (selectedWhiteLabel) {
      if (myWhiteLabelProject.data.list.length > 1) {
        title = (
          <span>
            {messages.plugins}
            {' • '}
            <DropdownButton title={selectedWhiteLabel.name}>
              {myWhiteLabelProject.data.list.map((whiteLabelProject, i) => {
                return (
                  <MenuItem
                    key={i}
                    eventKey={i}
                    onSelect={() => this.setState({ selectedWhiteLabel: whiteLabelProject })}
                  >
                    {whiteLabelProject.name}
                  </MenuItem>
                );
              })}
            </DropdownButton>
          </span>
        );
      } else {
        title += ' • ' + selectedWhiteLabel.name;
      }
    }

    return (
      <DocMeta tags={generateMetaTags(messages.meta.plugins)}>
        <div>
          <List noRender listName="sepaAgreements" url="/api/sepaagreements.json" list={sepaAgreements} />
          <List noRender listName="myWhiteLabelProject" url="/api/whitelabels/my.json" list={myWhiteLabelProject} />
          <List
            noRender
            listName="externalAccountsStats"
            url="/api/externalaccountsstats.json"
            list={externalAccountsStats}
          />
          {!!selectedWhiteLabel && (
            <>
              <List
                noRender
                listName="pluginActivationRequests"
                url={'/api/whitelabels/' + selectedWhiteLabel.id + '/pluginActivationRequests.json'}
                list={pluginActivationRequests}
              />
              <List
                noRender
                listName="pluginTerminationRequests"
                url={'/api/whitelabels/' + selectedWhiteLabel.id + '/pluginTerminationRequests.json'}
                list={pluginTerminationRequests}
              />
            </>
          )}

          <List
            listName="whiteLabelPlugin"
            url="/api/whitelabelplugins.json"
            list={list}
            iconClass="fa fa-plug"
            title={title}
            breadcrumb={this.getBreadcrumb()}
            showSearch={false}
            showPagination={false}
          >
            {list.pending ? (
              <Loader />
            ) : (
              <div>
                {/* if the user is no administrator for a white label project, display a message */}
                {!myWhiteLabelProject.pending && !selectedWhiteLabel && (
                  <Alert bsStyle="warning">{messages.you_are_not_an_adminitrator}</Alert>
                )}

                {list.data.list.map(plugin => {
                  const pluginActive = this.isPluginActive(plugin);
                  const activationPending = pluginActive ? false : this.getActivationPending(plugin);
                  const terminationPending = pluginActive ? this.getTerminationPending(plugin) : false;

                  if (activationPending && !terminationPending && !plugin.dependent_on) {
                    return this.displayPlugin(plugin, pluginActive, activationPending, terminationPending);
                  }
                })}

                {list.data.list.map(plugin => {
                  const pluginActive = this.isPluginActive(plugin);
                  const terminationPending = pluginActive ? this.getTerminationPending(plugin) : false;

                  if (terminationPending && !plugin.dependent_on) {
                    return this.displayPlugin(plugin, pluginActive, false, terminationPending);
                  }
                })}

                {list.data.list.map(plugin => {
                  const pluginActive = this.isPluginActive(plugin);
                  const terminationPending = pluginActive ? this.getTerminationPending(plugin) : false;
                  const hasSepaAgreement = pluginActive ? this.hasSepaAgreement(plugin) : null;

                  if (pluginActive && !terminationPending && !plugin.dependent_on) {
                    return this.displayPlugin(plugin, pluginActive, false, false, hasSepaAgreement);
                  }
                })}

                {list.data.list.map(plugin => {
                  const pluginActive = this.isPluginActive(plugin);
                  const activationPending = pluginActive ? false : this.getActivationPending(plugin);

                  if (!pluginActive && !activationPending && !plugin.dependent_on) {
                    return this.displayPlugin(plugin, pluginActive);
                  }
                })}
              </div>
            )}
          </List>

          <div id="activate-plugin">
            <PluginActivate
              plugin={detailsPlugin}
              show={showActivate}
              close={this.closePopup}
              whiteLabelProject={selectedWhiteLabel}
            />
          </div>
          <div id="terminate-plugin">
            <PluginTerminate
              plugin={detailsPlugin}
              show={showTerminate}
              close={this.closePopup}
              whiteLabelProject={selectedWhiteLabel}
            />
          </div>
          <div id="plugin-details">
            <PluginDetails
              plugin={detailsPlugin}
              show={showDetails}
              close={this.closePopup}
              mayActivate={!this.isPluginActive(detailsPlugin) && selectedWhiteLabel}
              onActivate={() => this.pluginActivationChange(detailsPlugin, true)}
            />
          </div>
          <div id="plugin-settings">
            <PluginSettings
              plugin={settingsPlugin}
              show={showSettings}
              close={this.closePopup}
              whiteLabelProject={selectedWhiteLabel}
            />
          </div>
        </div>
      </DocMeta>
    );
  }
}

const mapStateToProps = state => {
  return {
    appIntl: state.intl,
    user: state.login.user,
    list: state.list.whiteLabelPlugin,
    myWhiteLabelProject: state.list.myWhiteLabelProject,
    externalAccountsStats: state.list.externalAccountsStats,
    sepaAgreements: state.list.sepaAgreements,
    pluginActivationRequests: state.list.pluginActivationRequests,
    pluginTerminationRequests: state.list.pluginTerminationRequests,
    pluginTerminateFormStatus: state.formStatus.pluginTerminate,
    pluginActivateFormStatus: state.formStatus.pluginActivate,
    pluginSettingsFormStatus: state.formStatus.pluginSettingsEdit,
  };
};
const mapDispatchToProps = dispatch => {
  return {
    doNotify: (code, text) => {
      dispatch(addNotification(code, text));
    },
  };
};

export default withRouter(
  injectIntl(
    connect(
      mapStateToProps,
      mapDispatchToProps
    )(Plugins)
  )
);
